/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Share_App_LogsInputs */

const en_settings_share_app_logs = /** @type {(inputs: Settings_Share_App_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share app logs`)
};

const es_settings_share_app_logs = /** @type {(inputs: Settings_Share_App_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir registros de la app`)
};

/**
* | output |
* | --- |
* | "Share app logs" |
*
* @param {Settings_Share_App_LogsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_share_app_logs = /** @type {((inputs?: Settings_Share_App_LogsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Share_App_LogsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_share_app_logs(inputs)
	return en_settings_share_app_logs(inputs)
});